export default {
  entities: null,
  purchases: null,
  showPersonalDetails: {
    isLoading: true,
    error: {}
  },
  updatePersonalInformation: {
    isLoading: false,
    error: {}
  },
  updatePassword: {
    isLoading: false,
    error: {}
  },
  updateContactsDetails: {
    isLoading: false,
    error: {}
  },
  updateAddress: {
    isLoading: false,
    error: {}
  },
  userProfileData: {
    isLoading: true,
    error: {}
  },
  updateUserProfileData: {
    isLoading: false,
    error: {}
  }
};
